import { useEffect, useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import Card from '../../Card/Card';
import CopyShortcodeInput from '../../FormElements/CopyShortcodeInput/CopyShortcodeInput';
import styles from './TabSections.module.css';

const ShortcodesSettings = ({ onSave, onReset, settingsData, onSettingsChange, showToast }) => {
  const [settings, setSettings] = useState({
    hvnly_propertySearch: "[hvnly_property_search]",
    hvnly_propertyGrid: "[hvnly_property_grid]",
    hvnly_propertyLists: "[hvnly_property_lists]",
    // Property Grid Variations
    hvnly_propertyGridColumns2: "[hvnly_property_grid columns='2']",
    hvnly_propertyGridColumns3: "[hvnly_property_grid columns='3']",
    hvnly_propertyGridColumns4: "[hvnly_property_grid columns='4']",
    hvnly_propertyGridColumns5: "[hvnly_property_grid columns='5']",
    hvnly_propertyGridColumns6: "[hvnly_property_grid columns='6']",
    hvnly_propertyGridFeatured: "[hvnly_property_grid featured_only='yes']",
    hvnly_propertyGridRent: "[hvnly_property_grid department='rent']",
    hvnly_propertyGridSale: "[hvnly_property_grid department='sale']",
    hvnly_propertyGridCommercial: "[hvnly_property_grid department='commercial']",
    hvnly_propertyGridLet: "[hvnly_property_grid department='let']",
    hvnly_propertyGridFeaturedRent: "[hvnly_property_grid department='rent' featured_only='yes']",
    hvnly_propertyGridFeaturedSale: "[hvnly_property_grid department='sale' featured_only='yes']",
    hvnly_propertyGridPriceRangeRent: "[hvnly_property_grid department='rent' min_price='200000' max_price='500000']",
    hvnly_propertyGridPriceRangeSale: "[hvnly_property_grid department='sale' min_price='500000' max_price='1000000']",
    hvnly_propertyGridBedrooms: "[hvnly_property_grid department='rent' bedrooms='3']",
    hvnly_propertyGridBedroomsSale: "[hvnly_property_grid department='sale' bedrooms='4']",
    hvnly_propertyGridBedroomsFeatured: "[hvnly_property_grid department='rent' bedrooms='2' featured_only='yes']",
    hvnly_propertyGridBathrooms: "[hvnly_property_grid department='rent' bathrooms='2']",
    hvnly_propertyGridBathroomsSale: "[hvnly_property_grid department='sale' bathrooms='3']",
    hvnly_propertyGridReceptionRooms: "[hvnly_property_grid department='rent' reception_rooms='2']",
    hvnly_propertyGridMultipleFilters: "[hvnly_property_grid department='rent' bedrooms='3' bathrooms='2' featured_only='yes']",
    hvnly_propertyGridMultipleFiltersSale: "[hvnly_property_grid department='sale' bedrooms='4' bathrooms='3' min_price='500000']",
    hvnly_propertyGridPropertyTypeApartment: "[hvnly_property_grid property_type='apartment' department='rent']",
    hvnly_propertyGridPropertyTypeHouse: "[hvnly_property_grid type='house' department='sale']",
    hvnly_propertyGridPropertyTypeCondo: "[hvnly_property_grid category='condo' department='rent']",
    hvnly_propertyGridLocationNY: "[hvnly_property_grid location='new-york' department='rent']",
    hvnly_propertyGridLocationLA: "[hvnly_property_grid location='los-angeles' department='sale']",
    hvnly_propertyGridStatusSale: "[hvnly_property_grid status='for-sale' department='sale']",
    hvnly_propertyGridStatusRent: "[hvnly_property_grid status='for-rent' department='rent']",
    hvnly_propertyGridFeaturePool: "[hvnly_property_grid feature='pool' department='rent']",
    hvnly_propertyGridFeaturesGarageGarden: "[hvnly_property_grid features='garage,garden' department='sale']",
    hvnly_propertyGridTagLuxury: "[hvnly_property_grid tag='luxury' department='rent']",
    hvnly_propertyGridTagsWaterfront: "[hvnly_property_grid tags='waterfront,new' department='sale']",
    hvnly_propertyGridBadgeFeatured: "[hvnly_property_grid badge='featured' department='rent']",
    hvnly_propertyGridBadgesNew: "[hvnly_property_grid badges='new,popular' department='sale']",
    hvnly_propertyGridAreaSqft: "[hvnly_property_grid department='rent' sqft='1500']",
    hvnly_propertyGridArea: "[hvnly_property_grid department='sale' area='2000']",
    hvnly_propertyGridGarage: "[hvnly_property_grid department='rent' garage='2']",
    hvnly_propertyGridYearBuilt: "[hvnly_property_grid department='rent' year_built='2020']",
    hvnly_propertyGridPostsPerPage10: "[hvnly_property_grid department='rent' posts_per_page='10']",
    hvnly_propertyGridPostsPerPage15: "[hvnly_property_grid department='sale' posts_per_page='15']",
    hvnly_propertyGridSpecificIds: "[hvnly_property_grid ids='PR-2025-00000001,PR-2025-00000005']",
    hvnly_propertyGridExcludeIds: "[hvnly_property_grid department='rent' exclude='PR-2025-00000003']",
    hvnly_propertyGridOrderByPriceLow: "[hvnly_property_grid department='rent' orderby='price_low']",
    hvnly_propertyGridOrderByPriceHigh: "[hvnly_property_grid department='sale' orderby='price_high']",
    hvnly_propertyGridOrderByDateAsc: "[hvnly_property_grid department='rent' orderby='date_asc']",
    hvnly_propertyGridOrderByDateDesc: "[hvnly_property_grid department='rent' orderby='date_desc']",
    hvnly_propertyGridOrderByTitleAsc: "[hvnly_property_grid department='rent' orderby='title_asc']",
    hvnly_propertyGridOrderByTitleDesc: "[hvnly_property_grid department='rent' orderby='title_desc']",
    hvnly_propertyGridOrderByBedrooms: "[hvnly_property_grid department='rent' orderby='bedrooms']",
    hvnly_propertyGridOrderByBathrooms: "[hvnly_property_grid department='rent' orderby='bathrooms']",
    hvnly_propertyGridOrderByArea: "[hvnly_property_grid department='rent' orderby='area']",
    hvnly_propertyGridOrderByRand: "[hvnly_property_grid department='rent' orderby='rand']",
    hvnly_propertyGridHidePagination: "[hvnly_property_grid department='rent' show_pagination='no' posts_per_page='5']",
    hvnly_propertyGridCustomClass: "[hvnly_property_grid department='rent' class='my-custom-grid' id='rent-properties']",
    hvnly_propertyGridResultsBarTop: "[hvnly_property_grid department='rent' results_bar_position='top']",
    hvnly_propertyGridResultsBarBottom: "[hvnly_property_grid department='rent' results_bar_position='bottom']",
    hvnly_propertyGridResultsBarBoth: "[hvnly_property_grid department='rent' results_bar_position='both']",
    hvnly_propertyGridHideResultsCount: "[hvnly_property_grid department='rent' show_results_count='no']",
    // Property List Variations
    hvnly_propertyListBasic: "[hvnly_property_list]",
    hvnly_propertyListFeatured: "[hvnly_property_list featured_only='yes']",
    hvnly_propertyListRent: "[hvnly_property_list department='rent']",
    hvnly_propertyListSale: "[hvnly_property_list department='sale']",
    hvnly_propertyListCommercial: "[hvnly_property_list department='commercial']",
    hvnly_propertyListLet: "[hvnly_property_list department='let']",
    hvnly_propertyListFeaturedRent: "[hvnly_property_list department='rent' featured_only='yes']",
    hvnly_propertyListFeaturedSale: "[hvnly_property_list department='sale' featured_only='yes']",
    hvnly_propertyListPriceRangeRent: "[hvnly_property_list department='rent' min_price='200000' max_price='500000']",
    hvnly_propertyListPriceRangeSale: "[hvnly_property_list department='sale' min_price='500000' max_price='1000000']",
    hvnly_propertyListBedrooms: "[hvnly_property_list department='rent' bedrooms='3']",
    hvnly_propertyListBedroomsSale: "[hvnly_property_list department='sale' bedrooms='4']",
    hvnly_propertyListBedroomsFeatured: "[hvnly_property_list department='rent' bedrooms='2' featured_only='yes']",
    hvnly_propertyListBathrooms: "[hvnly_property_list department='rent' bathrooms='2']",
    hvnly_propertyListBathroomsSale: "[hvnly_property_list department='sale' bathrooms='3']",
    hvnly_propertyListMultipleFilters: "[hvnly_property_list department='rent' bedrooms='3' bathrooms='2' featured_only='yes']",
    hvnly_propertyListMultipleFiltersSale: "[hvnly_property_list department='sale' bedrooms='4' bathrooms='3' min_price='500000']",
    hvnly_propertyListPropertyTypeApartment: "[hvnly_property_list property_type='apartment' department='rent']",
    hvnly_propertyListPropertyTypeHouse: "[hvnly_property_list type='house' department='sale']",
    hvnly_propertyListPropertyTypeCondo: "[hvnly_property_list category='condo' department='rent']",
    hvnly_propertyListLocationNY: "[hvnly_property_list location='new-york' department='rent']",
    hvnly_propertyListLocationLA: "[hvnly_property_list location='los-angeles' department='sale']",
    hvnly_propertyListStatusSale: "[hvnly_property_list status='for-sale' department='sale']",
    hvnly_propertyListStatusRent: "[hvnly_property_list status='for-rent' department='rent']",
    hvnly_propertyListFeaturePool: "[hvnly_property_list feature='pool' department='rent']",
    hvnly_propertyListFeaturesGarageGarden: "[hvnly_property_list features='garage,garden' department='sale']",
    hvnly_propertyListTagLuxury: "[hvnly_property_list tag='luxury' department='rent']",
    hvnly_propertyListTagsWaterfront: "[hvnly_property_list tags='waterfront,new' department='sale']",
    hvnly_propertyListBadgeFeatured: "[hvnly_property_list badge='featured' department='rent']",
    hvnly_propertyListBadgesNew: "[hvnly_property_list badges='new,popular' department='sale']",
    hvnly_propertyListAreaSqft: "[hvnly_property_list department='rent' sqft='1500']",
    hvnly_propertyListArea: "[hvnly_property_list department='sale' area='2000']",
    hvnly_propertyListGarage: "[hvnly_property_list department='rent' garage='2']",
    hvnly_propertyListYearBuilt: "[hvnly_property_list department='rent' year_built='2020']",
    hvnly_propertyListPostsPerPage10: "[hvnly_property_list department='rent' posts_per_page='10']",
    hvnly_propertyListPostsPerPage15: "[hvnly_property_list department='sale' posts_per_page='15']",
    hvnly_propertyListSpecificIds: "[hvnly_property_list ids='PR-2025-00000001,PR-2025-00000005']",
    hvnly_propertyListExcludeIds: "[hvnly_property_list department='rent' exclude='PR-2025-00000003']",
    hvnly_propertyListOrderByPriceLow: "[hvnly_property_list department='rent' orderby='price_low']",
    hvnly_propertyListOrderByPriceHigh: "[hvnly_property_list department='sale' orderby='price_high']",
    hvnly_propertyListOrderByDateAsc: "[hvnly_property_list department='rent' orderby='date_asc']",
    hvnly_propertyListOrderByDateDesc: "[hvnly_property_list department='rent' orderby='date_desc']",
    hvnly_propertyListOrderByTitleAsc: "[hvnly_property_list department='rent' orderby='title_asc']",
    hvnly_propertyListOrderByTitleDesc: "[hvnly_property_list department='rent' orderby='title_desc']",
    hvnly_propertyListOrderByBedrooms: "[hvnly_property_list department='rent' orderby='bedrooms']",
    hvnly_propertyListOrderByBathrooms: "[hvnly_property_list department='rent' orderby='bathrooms']",
    hvnly_propertyListOrderByArea: "[hvnly_property_list department='rent' orderby='area']",
    hvnly_propertyListOrderByRand: "[hvnly_property_list department='rent' orderby='rand']",
    hvnly_propertyListHidePagination: "[hvnly_property_list department='rent' show_pagination='no' posts_per_page='5']",
    hvnly_propertyListCustomClass: "[hvnly_property_list department='rent' class='my-custom-list' id='rent-properties']",
    hvnly_propertyListResultsBarTop: "[hvnly_property_list department='rent' results_bar_position='top']",
    hvnly_propertyListResultsBarBottom: "[hvnly_property_list department='rent' results_bar_position='bottom']",
    hvnly_propertyListResultsBarBoth: "[hvnly_property_list department='rent' results_bar_position='both']",
    hvnly_propertyListHideResultsCount: "[hvnly_property_list department='rent' show_results_count='no']"
  });

  useEffect(() => {
    if (settingsData && Object.keys(settingsData).length > 0) {
      setSettings(prev => ({ ...prev, ...settingsData }));
    }
  }, [settingsData]);

  const handleInputChange = (field, value) => {
    const newSettings = { ...settings, [field]: value };
    setSettings(newSettings);
    if (onSettingsChange) {
      onSettingsChange(newSettings);
    }
  };

  const handleSave = async () => {
    if (onSave) {
      await onSave(settings);
      return true;
    }
    return false;
  };

  const handleReset = async () => {
    const defaultSettings = {
      hvnly_propertySearch: "[hvnly_property_search]",
      hvnly_propertyGrid: "[hvnly_property_grid]",
      hvnly_propertyLists: "[hvnly_property_lists]",
      // Property Grid Variations
      hvnly_propertyGridColumns2: "[hvnly_property_grid columns='2']",
      hvnly_propertyGridColumns3: "[hvnly_property_grid columns='3']",
      hvnly_propertyGridColumns4: "[hvnly_property_grid columns='4']",
      hvnly_propertyGridColumns5: "[hvnly_property_grid columns='5']",
      hvnly_propertyGridColumns6: "[hvnly_property_grid columns='6']",
      hvnly_propertyGridFeatured: "[hvnly_property_grid featured_only='yes']",
      hvnly_propertyGridRent: "[hvnly_property_grid department='rent']",
      hvnly_propertyGridSale: "[hvnly_property_grid department='sale']",
      hvnly_propertyGridCommercial: "[hvnly_property_grid department='commercial']",
      hvnly_propertyGridLet: "[hvnly_property_grid department='let']",
      hvnly_propertyGridFeaturedRent: "[hvnly_property_grid department='rent' featured_only='yes']",
      hvnly_propertyGridFeaturedSale: "[hvnly_property_grid department='sale' featured_only='yes']",
      hvnly_propertyGridPriceRangeRent: "[hvnly_property_grid department='rent' min_price='200000' max_price='500000']",
      hvnly_propertyGridPriceRangeSale: "[hvnly_property_grid department='sale' min_price='500000' max_price='1000000']",
      hvnly_propertyGridBedrooms: "[hvnly_property_grid department='rent' bedrooms='3']",
      hvnly_propertyGridBedroomsSale: "[hvnly_property_grid department='sale' bedrooms='4']",
      hvnly_propertyGridBedroomsFeatured: "[hvnly_property_grid department='rent' bedrooms='2' featured_only='yes']",
      hvnly_propertyGridBathrooms: "[hvnly_property_grid department='rent' bathrooms='2']",
      hvnly_propertyGridBathroomsSale: "[hvnly_property_grid department='sale' bathrooms='3']",
      hvnly_propertyGridReceptionRooms: "[hvnly_property_grid department='rent' reception_rooms='2']",
      hvnly_propertyGridMultipleFilters: "[hvnly_property_grid department='rent' bedrooms='3' bathrooms='2' featured_only='yes']",
      hvnly_propertyGridMultipleFiltersSale: "[hvnly_property_grid department='sale' bedrooms='4' bathrooms='3' min_price='500000']",
      hvnly_propertyGridPropertyTypeApartment: "[hvnly_property_grid property_type='apartment' department='rent']",
      hvnly_propertyGridPropertyTypeHouse: "[hvnly_property_grid type='house' department='sale']",
      hvnly_propertyGridPropertyTypeCondo: "[hvnly_property_grid category='condo' department='rent']",
      hvnly_propertyGridLocationNY: "[hvnly_property_grid location='new-york' department='rent']",
      hvnly_propertyGridLocationLA: "[hvnly_property_grid location='los-angeles' department='sale']",
      hvnly_propertyGridStatusSale: "[hvnly_property_grid status='for-sale' department='sale']",
      hvnly_propertyGridStatusRent: "[hvnly_property_grid status='for-rent' department='rent']",
      hvnly_propertyGridFeaturePool: "[hvnly_property_grid feature='pool' department='rent']",
      hvnly_propertyGridFeaturesGarageGarden: "[hvnly_property_grid features='garage,garden' department='sale']",
      hvnly_propertyGridTagLuxury: "[hvnly_property_grid tag='luxury' department='rent']",
      hvnly_propertyGridTagsWaterfront: "[hvnly_property_grid tags='waterfront,new' department='sale']",
      hvnly_propertyGridBadgeFeatured: "[hvnly_property_grid badge='featured' department='rent']",
      hvnly_propertyGridBadgesNew: "[hvnly_property_grid badges='new,popular' department='sale']",
      hvnly_propertyGridAreaSqft: "[hvnly_property_grid department='rent' sqft='1500']",
      hvnly_propertyGridArea: "[hvnly_property_grid department='sale' area='2000']",
      hvnly_propertyGridGarage: "[hvnly_property_grid department='rent' garage='2']",
      hvnly_propertyGridYearBuilt: "[hvnly_property_grid department='rent' year_built='2020']",
      hvnly_propertyGridPostsPerPage10: "[hvnly_property_grid department='rent' posts_per_page='10']",
      hvnly_propertyGridPostsPerPage15: "[hvnly_property_grid department='sale' posts_per_page='15']",
      hvnly_propertyGridSpecificIds: "[hvnly_property_grid ids='PR-2025-00000001,PR-2025-00000005']",
      hvnly_propertyGridExcludeIds: "[hvnly_property_grid department='rent' exclude='PR-2025-00000003']",
      hvnly_propertyGridOrderByPriceLow: "[hvnly_property_grid department='rent' orderby='price_low']",
      hvnly_propertyGridOrderByPriceHigh: "[hvnly_property_grid department='sale' orderby='price_high']",
      hvnly_propertyGridOrderByDateAsc: "[hvnly_property_grid department='rent' orderby='date_asc']",
      hvnly_propertyGridOrderByDateDesc: "[hvnly_property_grid department='rent' orderby='date_desc']",
      hvnly_propertyGridOrderByTitleAsc: "[hvnly_property_grid department='rent' orderby='title_asc']",
      hvnly_propertyGridOrderByTitleDesc: "[hvnly_property_grid department='rent' orderby='title_desc']",
      hvnly_propertyGridOrderByBedrooms: "[hvnly_property_grid department='rent' orderby='bedrooms']",
      hvnly_propertyGridOrderByBathrooms: "[hvnly_property_grid department='rent' orderby='bathrooms']",
      hvnly_propertyGridOrderByArea: "[hvnly_property_grid department='rent' orderby='area']",
      hvnly_propertyGridOrderByRand: "[hvnly_property_grid department='rent' orderby='rand']",
      hvnly_propertyGridHidePagination: "[hvnly_property_grid department='rent' show_pagination='no' posts_per_page='5']",
      hvnly_propertyGridCustomClass: "[hvnly_property_grid department='rent' class='my-custom-grid' id='rent-properties']",
      hvnly_propertyGridResultsBarTop: "[hvnly_property_grid department='rent' results_bar_position='top']",
      hvnly_propertyGridResultsBarBottom: "[hvnly_property_grid department='rent' results_bar_position='bottom']",
      hvnly_propertyGridResultsBarBoth: "[hvnly_property_grid department='rent' results_bar_position='both']",
      hvnly_propertyGridHideResultsCount: "[hvnly_property_grid department='rent' show_results_count='no']",
      // Property List Variations
      hvnly_propertyListBasic: "[hvnly_property_list]",
      hvnly_propertyListFeatured: "[hvnly_property_list featured_only='yes']",
      hvnly_propertyListRent: "[hvnly_property_list department='rent']",
      hvnly_propertyListSale: "[hvnly_property_list department='sale']",
      hvnly_propertyListCommercial: "[hvnly_property_list department='commercial']",
      hvnly_propertyListLet: "[hvnly_property_list department='let']",
      hvnly_propertyListFeaturedRent: "[hvnly_property_list department='rent' featured_only='yes']",
      hvnly_propertyListFeaturedSale: "[hvnly_property_list department='sale' featured_only='yes']",
      hvnly_propertyListPriceRangeRent: "[hvnly_property_list department='rent' min_price='200000' max_price='500000']",
      hvnly_propertyListPriceRangeSale: "[hvnly_property_list department='sale' min_price='500000' max_price='1000000']",
      hvnly_propertyListBedrooms: "[hvnly_property_list department='rent' bedrooms='3']",
      hvnly_propertyListBedroomsSale: "[hvnly_property_list department='sale' bedrooms='4']",
      hvnly_propertyListBedroomsFeatured: "[hvnly_property_list department='rent' bedrooms='2' featured_only='yes']",
      hvnly_propertyListBathrooms: "[hvnly_property_list department='rent' bathrooms='2']",
      hvnly_propertyListBathroomsSale: "[hvnly_property_list department='sale' bathrooms='3']",
      hvnly_propertyListMultipleFilters: "[hvnly_property_list department='rent' bedrooms='3' bathrooms='2' featured_only='yes']",
      hvnly_propertyListMultipleFiltersSale: "[hvnly_property_list department='sale' bedrooms='4' bathrooms='3' min_price='500000']",
      hvnly_propertyListPropertyTypeApartment: "[hvnly_property_list property_type='apartment' department='rent']",
      hvnly_propertyListPropertyTypeHouse: "[hvnly_property_list type='house' department='sale']",
      hvnly_propertyListPropertyTypeCondo: "[hvnly_property_list category='condo' department='rent']",
      hvnly_propertyListLocationNY: "[hvnly_property_list location='new-york' department='rent']",
      hvnly_propertyListLocationLA: "[hvnly_property_list location='los-angeles' department='sale']",
      hvnly_propertyListStatusSale: "[hvnly_property_list status='for-sale' department='sale']",
      hvnly_propertyListStatusRent: "[hvnly_property_list status='for-rent' department='rent']",
      hvnly_propertyListFeaturePool: "[hvnly_property_list feature='pool' department='rent']",
      hvnly_propertyListFeaturesGarageGarden: "[hvnly_property_list features='garage,garden' department='sale']",
      hvnly_propertyListTagLuxury: "[hvnly_property_list tag='luxury' department='rent']",
      hvnly_propertyListTagsWaterfront: "[hvnly_property_list tags='waterfront,new' department='sale']",
      hvnly_propertyListBadgeFeatured: "[hvnly_property_list badge='featured' department='rent']",
      hvnly_propertyListBadgesNew: "[hvnly_property_list badges='new,popular' department='sale']",
      hvnly_propertyListAreaSqft: "[hvnly_property_list department='rent' sqft='1500']",
      hvnly_propertyListArea: "[hvnly_property_list department='sale' area='2000']",
      hvnly_propertyListGarage: "[hvnly_property_list department='rent' garage='2']",
      hvnly_propertyListYearBuilt: "[hvnly_property_list department='rent' year_built='2020']",
      hvnly_propertyListPostsPerPage10: "[hvnly_property_list department='rent' posts_per_page='10']",
      hvnly_propertyListPostsPerPage15: "[hvnly_property_list department='sale' posts_per_page='15']",
      hvnly_propertyListSpecificIds: "[hvnly_property_list ids='PR-2025-00000001,PR-2025-00000005']",
      hvnly_propertyListExcludeIds: "[hvnly_property_list department='rent' exclude='PR-2025-00000003']",
      hvnly_propertyListOrderByPriceLow: "[hvnly_property_list department='rent' orderby='price_low']",
      hvnly_propertyListOrderByPriceHigh: "[hvnly_property_list department='sale' orderby='price_high']",
      hvnly_propertyListOrderByDateAsc: "[hvnly_property_list department='rent' orderby='date_asc']",
      hvnly_propertyListOrderByDateDesc: "[hvnly_property_list department='rent' orderby='date_desc']",
      hvnly_propertyListOrderByTitleAsc: "[hvnly_property_list department='rent' orderby='title_asc']",
      hvnly_propertyListOrderByTitleDesc: "[hvnly_property_list department='rent' orderby='title_desc']",
      hvnly_propertyListOrderByBedrooms: "[hvnly_property_list department='rent' orderby='bedrooms']",
      hvnly_propertyListOrderByBathrooms: "[hvnly_property_list department='rent' orderby='bathrooms']",
      hvnly_propertyListOrderByArea: "[hvnly_property_list department='rent' orderby='area']",
      hvnly_propertyListOrderByRand: "[hvnly_property_list department='rent' orderby='rand']",
      hvnly_propertyListHidePagination: "[hvnly_property_list department='rent' show_pagination='no' posts_per_page='5']",
      hvnly_propertyListCustomClass: "[hvnly_property_list department='rent' class='my-custom-list' id='rent-properties']",
      hvnly_propertyListResultsBarTop: "[hvnly_property_list department='rent' results_bar_position='top']",
      hvnly_propertyListResultsBarBottom: "[hvnly_property_list department='rent' results_bar_position='bottom']",
      hvnly_propertyListResultsBarBoth: "[hvnly_property_list department='rent' results_bar_position='both']",
      hvnly_propertyListHideResultsCount: "[hvnly_property_list department='rent' show_results_count='no']"
    };
    setSettings(defaultSettings);
    if (onSettingsChange) {
      onSettingsChange(defaultSettings);
    }
    if (onReset) {
      await onReset();
      return true;
    }
    return false;
  };

  return (
    <div className={`${styles['hvnly-settings-api__content']} ${styles['hvnly-settings-api__content--active']}`} id="shortcodes">
      <h2>{__('Shortcodes', 'havenlytics')}</h2>

      <Card title={__("Basic Shortcodes", "havenlytics")} icon="fas fa-code" collapsible>
        <div className={styles['hvnly-settings-api__form-group']}>
          <CopyShortcodeInput
            label={__("Property Search Shortcode", "havenlytics")}
            id="hvnly_shortcode_property_search"
            value={settings.hvnly_propertySearch}
            onChange={(val) => handleInputChange("hvnly_propertySearch", val)}
          />

          <CopyShortcodeInput
            label={__("Property Grid Shortcode", "havenlytics")}
            id="hvnly_shortcode_property_grid"
            value={settings.hvnly_propertyGrid}
            onChange={(val) => handleInputChange("hvnly_propertyGrid", val)}
          />

          <CopyShortcodeInput
            label={__("Property Lists Shortcode", "havenlytics")}
            id="hvnly_shortcode_property_lists"
            value={settings.hvnly_propertyLists}
            onChange={(val) => handleInputChange("hvnly_propertyLists", val)}
          />
        </div>
      </Card>

      <Card title={__("Property Grid Variations", "havenlytics")} icon="fas fa-th" collapsible defaultCollapsed>
        <div className={styles['hvnly-settings-api__form-group']}>
          <h3>{__("Columns", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("2 Columns", "havenlytics")}
            id="hvnly_shortcode_grid_columns_2"
            value={settings.hvnly_propertyGridColumns2}
            onChange={(val) => handleInputChange("hvnly_propertyGridColumns2", val)}
          />
          <CopyShortcodeInput
            label={__("3 Columns", "havenlytics")}
            id="hvnly_shortcode_grid_columns_3"
            value={settings.hvnly_propertyGridColumns3}
            onChange={(val) => handleInputChange("hvnly_propertyGridColumns3", val)}
          />
          <CopyShortcodeInput
            label={__("4 Columns", "havenlytics")}
            id="hvnly_shortcode_grid_columns_4"
            value={settings.hvnly_propertyGridColumns4}
            onChange={(val) => handleInputChange("hvnly_propertyGridColumns4", val)}
          />
          <CopyShortcodeInput
            label={__("5 Columns", "havenlytics")}
            id="hvnly_shortcode_grid_columns_5"
            value={settings.hvnly_propertyGridColumns5}
            onChange={(val) => handleInputChange("hvnly_propertyGridColumns5", val)}
          />
          <CopyShortcodeInput
            label={__("6 Columns", "havenlytics")}
            id="hvnly_shortcode_grid_columns_6"
            value={settings.hvnly_propertyGridColumns6}
            onChange={(val) => handleInputChange("hvnly_propertyGridColumns6", val)}
          />

          <h3>{__("Featured Properties", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Featured Only", "havenlytics")}
            id="hvnly_shortcode_grid_featured"
            value={settings.hvnly_propertyGridFeatured}
            onChange={(val) => handleInputChange("hvnly_propertyGridFeatured", val)}
          />

          <h3>{__("Department Filters", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent", "havenlytics")}
            id="hvnly_shortcode_grid_rent"
            value={settings.hvnly_propertyGridRent}
            onChange={(val) => handleInputChange("hvnly_propertyGridRent", val)}
          />
          <CopyShortcodeInput
            label={__("Sale", "havenlytics")}
            id="hvnly_shortcode_grid_sale"
            value={settings.hvnly_propertyGridSale}
            onChange={(val) => handleInputChange("hvnly_propertyGridSale", val)}
          />
          <CopyShortcodeInput
            label={__("Commercial", "havenlytics")}
            id="hvnly_shortcode_grid_commercial"
            value={settings.hvnly_propertyGridCommercial}
            onChange={(val) => handleInputChange("hvnly_propertyGridCommercial", val)}
          />
          <CopyShortcodeInput
            label={__("Let", "havenlytics")}
            id="hvnly_shortcode_grid_let"
            value={settings.hvnly_propertyGridLet}
            onChange={(val) => handleInputChange("hvnly_propertyGridLet", val)}
          />

          <h3>{__("Featured + Department", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Featured Rent", "havenlytics")}
            id="hvnly_shortcode_grid_featured_rent"
            value={settings.hvnly_propertyGridFeaturedRent}
            onChange={(val) => handleInputChange("hvnly_propertyGridFeaturedRent", val)}
          />
          <CopyShortcodeInput
            label={__("Featured Sale", "havenlytics")}
            id="hvnly_shortcode_grid_featured_sale"
            value={settings.hvnly_propertyGridFeaturedSale}
            onChange={(val) => handleInputChange("hvnly_propertyGridFeaturedSale", val)}
          />

          <h3>{__("Price Range", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent ($200k - $500k)", "havenlytics")}
            id="hvnly_shortcode_grid_price_range_rent"
            value={settings.hvnly_propertyGridPriceRangeRent}
            onChange={(val) => handleInputChange("hvnly_propertyGridPriceRangeRent", val)}
          />
          <CopyShortcodeInput
            label={__("Sale ($500k - $1M)", "havenlytics")}
            id="hvnly_shortcode_grid_price_range_sale"
            value={settings.hvnly_propertyGridPriceRangeSale}
            onChange={(val) => handleInputChange("hvnly_propertyGridPriceRangeSale", val)}
          />

          <h3>{__("Bedrooms Filter", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent - 3 Bedrooms", "havenlytics")}
            id="hvnly_shortcode_grid_bedrooms"
            value={settings.hvnly_propertyGridBedrooms}
            onChange={(val) => handleInputChange("hvnly_propertyGridBedrooms", val)}
          />
          <CopyShortcodeInput
            label={__("Sale - 4 Bedrooms", "havenlytics")}
            id="hvnly_shortcode_grid_bedrooms_sale"
            value={settings.hvnly_propertyGridBedroomsSale}
            onChange={(val) => handleInputChange("hvnly_propertyGridBedroomsSale", val)}
          />
          <CopyShortcodeInput
            label={__("Rent - 2 Bedrooms Featured", "havenlytics")}
            id="hvnly_shortcode_grid_bedrooms_featured"
            value={settings.hvnly_propertyGridBedroomsFeatured}
            onChange={(val) => handleInputChange("hvnly_propertyGridBedroomsFeatured", val)}
          />

          <h3>{__("Bathrooms Filter", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent - 2 Bathrooms", "havenlytics")}
            id="hvnly_shortcode_grid_bathrooms"
            value={settings.hvnly_propertyGridBathrooms}
            onChange={(val) => handleInputChange("hvnly_propertyGridBathrooms", val)}
          />
          <CopyShortcodeInput
            label={__("Sale - 3 Bathrooms", "havenlytics")}
            id="hvnly_shortcode_grid_bathrooms_sale"
            value={settings.hvnly_propertyGridBathroomsSale}
            onChange={(val) => handleInputChange("hvnly_propertyGridBathroomsSale", val)}
          />

          <h3>{__("Reception Rooms", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent - 2 Reception Rooms", "havenlytics")}
            id="hvnly_shortcode_grid_reception_rooms"
            value={settings.hvnly_propertyGridReceptionRooms}
            onChange={(val) => handleInputChange("hvnly_propertyGridReceptionRooms", val)}
          />

          <h3>{__("Multiple Filters", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent: 3 Bed, 2 Bath, Featured", "havenlytics")}
            id="hvnly_shortcode_grid_multiple_filters"
            value={settings.hvnly_propertyGridMultipleFilters}
            onChange={(val) => handleInputChange("hvnly_propertyGridMultipleFilters", val)}
          />
          <CopyShortcodeInput
            label={__("Sale: 4 Bed, 3 Bath, Min $500k", "havenlytics")}
            id="hvnly_shortcode_grid_multiple_filters_sale"
            value={settings.hvnly_propertyGridMultipleFiltersSale}
            onChange={(val) => handleInputChange("hvnly_propertyGridMultipleFiltersSale", val)}
          />

          <h3>{__("Property Type", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Apartment for Rent", "havenlytics")}
            id="hvnly_shortcode_grid_property_type_apartment"
            value={settings.hvnly_propertyGridPropertyTypeApartment}
            onChange={(val) => handleInputChange("hvnly_propertyGridPropertyTypeApartment", val)}
          />
          <CopyShortcodeInput
            label={__("House for Sale", "havenlytics")}
            id="hvnly_shortcode_grid_property_type_house"
            value={settings.hvnly_propertyGridPropertyTypeHouse}
            onChange={(val) => handleInputChange("hvnly_propertyGridPropertyTypeHouse", val)}
          />
          <CopyShortcodeInput
            label={__("Condo for Rent", "havenlytics")}
            id="hvnly_shortcode_grid_property_type_condo"
            value={settings.hvnly_propertyGridPropertyTypeCondo}
            onChange={(val) => handleInputChange("hvnly_propertyGridPropertyTypeCondo", val)}
          />

          <h3>{__("Location Filters", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("New York - Rent", "havenlytics")}
            id="hvnly_shortcode_grid_location_ny"
            value={settings.hvnly_propertyGridLocationNY}
            onChange={(val) => handleInputChange("hvnly_propertyGridLocationNY", val)}
          />
          <CopyShortcodeInput
            label={__("Los Angeles - Sale", "havenlytics")}
            id="hvnly_shortcode_grid_location_la"
            value={settings.hvnly_propertyGridLocationLA}
            onChange={(val) => handleInputChange("hvnly_propertyGridLocationLA", val)}
          />

          <h3>{__("Status Filters", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("For Sale", "havenlytics")}
            id="hvnly_shortcode_grid_status_sale"
            value={settings.hvnly_propertyGridStatusSale}
            onChange={(val) => handleInputChange("hvnly_propertyGridStatusSale", val)}
          />
          <CopyShortcodeInput
            label={__("For Rent", "havenlytics")}
            id="hvnly_shortcode_grid_status_rent"
            value={settings.hvnly_propertyGridStatusRent}
            onChange={(val) => handleInputChange("hvnly_propertyGridStatusRent", val)}
          />

          <h3>{__("Features", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Pool - Rent", "havenlytics")}
            id="hvnly_shortcode_grid_feature_pool"
            value={settings.hvnly_propertyGridFeaturePool}
            onChange={(val) => handleInputChange("hvnly_propertyGridFeaturePool", val)}
          />
          <CopyShortcodeInput
            label={__("Garage & Garden - Sale", "havenlytics")}
            id="hvnly_shortcode_grid_features_garage_garden"
            value={settings.hvnly_propertyGridFeaturesGarageGarden}
            onChange={(val) => handleInputChange("hvnly_propertyGridFeaturesGarageGarden", val)}
          />

          <h3>{__("Tags", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Luxury - Rent", "havenlytics")}
            id="hvnly_shortcode_grid_tag_luxury"
            value={settings.hvnly_propertyGridTagLuxury}
            onChange={(val) => handleInputChange("hvnly_propertyGridTagLuxury", val)}
          />
          <CopyShortcodeInput
            label={__("Waterfront & New - Sale", "havenlytics")}
            id="hvnly_shortcode_grid_tags_waterfront"
            value={settings.hvnly_propertyGridTagsWaterfront}
            onChange={(val) => handleInputChange("hvnly_propertyGridTagsWaterfront", val)}
          />

          <h3>{__("Badges", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Featured - Rent", "havenlytics")}
            id="hvnly_shortcode_grid_badge_featured"
            value={settings.hvnly_propertyGridBadgeFeatured}
            onChange={(val) => handleInputChange("hvnly_propertyGridBadgeFeatured", val)}
          />
          <CopyShortcodeInput
            label={__("New & Popular - Sale", "havenlytics")}
            id="hvnly_shortcode_grid_badges_new"
            value={settings.hvnly_propertyGridBadgesNew}
            onChange={(val) => handleInputChange("hvnly_propertyGridBadgesNew", val)}
          />

          <h3>{__("Area / Square Footage", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent - 1500 sqft", "havenlytics")}
            id="hvnly_shortcode_grid_area_sqft"
            value={settings.hvnly_propertyGridAreaSqft}
            onChange={(val) => handleInputChange("hvnly_propertyGridAreaSqft", val)}
          />
          <CopyShortcodeInput
            label={__("Sale - 2000 area", "havenlytics")}
            id="hvnly_shortcode_grid_area"
            value={settings.hvnly_propertyGridArea}
            onChange={(val) => handleInputChange("hvnly_propertyGridArea", val)}
          />

          <h3>{__("Garage", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent - 2 Garages", "havenlytics")}
            id="hvnly_shortcode_grid_garage"
            value={settings.hvnly_propertyGridGarage}
            onChange={(val) => handleInputChange("hvnly_propertyGridGarage", val)}
          />

          <h3>{__("Year Built", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent - Built 2020", "havenlytics")}
            id="hvnly_shortcode_grid_year_built"
            value={settings.hvnly_propertyGridYearBuilt}
            onChange={(val) => handleInputChange("hvnly_propertyGridYearBuilt", val)}
          />

          <h3>{__("Posts Per Page", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent - 10 per page", "havenlytics")}
            id="hvnly_shortcode_grid_posts_per_page_10"
            value={settings.hvnly_propertyGridPostsPerPage10}
            onChange={(val) => handleInputChange("hvnly_propertyGridPostsPerPage10", val)}
          />
          <CopyShortcodeInput
            label={__("Sale - 15 per page", "havenlytics")}
            id="hvnly_shortcode_grid_posts_per_page_15"
            value={settings.hvnly_propertyGridPostsPerPage15}
            onChange={(val) => handleInputChange("hvnly_propertyGridPostsPerPage15", val)}
          />

          <h3>{__("Specific Property IDs", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Include Specific Properties", "havenlytics")}
            id="hvnly_shortcode_grid_specific_ids"
            value={settings.hvnly_propertyGridSpecificIds}
            onChange={(val) => handleInputChange("hvnly_propertyGridSpecificIds", val)}
          />

          <h3>{__("Exclude Property IDs", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Exclude Specific Properties", "havenlytics")}
            id="hvnly_shortcode_grid_exclude_ids"
            value={settings.hvnly_propertyGridExcludeIds}
            onChange={(val) => handleInputChange("hvnly_propertyGridExcludeIds", val)}
          />

          <h3>{__("Custom Ordering", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Price: Low to High", "havenlytics")}
            id="hvnly_shortcode_grid_order_price_low"
            value={settings.hvnly_propertyGridOrderByPriceLow}
            onChange={(val) => handleInputChange("hvnly_propertyGridOrderByPriceLow", val)}
          />
          <CopyShortcodeInput
            label={__("Price: High to Low", "havenlytics")}
            id="hvnly_shortcode_grid_order_price_high"
            value={settings.hvnly_propertyGridOrderByPriceHigh}
            onChange={(val) => handleInputChange("hvnly_propertyGridOrderByPriceHigh", val)}
          />
          <CopyShortcodeInput
            label={__("Date: Oldest First", "havenlytics")}
            id="hvnly_shortcode_grid_order_date_asc"
            value={settings.hvnly_propertyGridOrderByDateAsc}
            onChange={(val) => handleInputChange("hvnly_propertyGridOrderByDateAsc", val)}
          />
          <CopyShortcodeInput
            label={__("Date: Newest First", "havenlytics")}
            id="hvnly_shortcode_grid_order_date_desc"
            value={settings.hvnly_propertyGridOrderByDateDesc}
            onChange={(val) => handleInputChange("hvnly_propertyGridOrderByDateDesc", val)}
          />
          <CopyShortcodeInput
            label={__("Title: A to Z", "havenlytics")}
            id="hvnly_shortcode_grid_order_title_asc"
            value={settings.hvnly_propertyGridOrderByTitleAsc}
            onChange={(val) => handleInputChange("hvnly_propertyGridOrderByTitleAsc", val)}
          />
          <CopyShortcodeInput
            label={__("Title: Z to A", "havenlytics")}
            id="hvnly_shortcode_grid_order_title_desc"
            value={settings.hvnly_propertyGridOrderByTitleDesc}
            onChange={(val) => handleInputChange("hvnly_propertyGridOrderByTitleDesc", val)}
          />
          <CopyShortcodeInput
            label={__("By Bedrooms", "havenlytics")}
            id="hvnly_shortcode_grid_order_bedrooms"
            value={settings.hvnly_propertyGridOrderByBedrooms}
            onChange={(val) => handleInputChange("hvnly_propertyGridOrderByBedrooms", val)}
          />
          <CopyShortcodeInput
            label={__("By Bathrooms", "havenlytics")}
            id="hvnly_shortcode_grid_order_bathrooms"
            value={settings.hvnly_propertyGridOrderByBathrooms}
            onChange={(val) => handleInputChange("hvnly_propertyGridOrderByBathrooms", val)}
          />
          <CopyShortcodeInput
            label={__("By Area", "havenlytics")}
            id="hvnly_shortcode_grid_order_area"
            value={settings.hvnly_propertyGridOrderByArea}
            onChange={(val) => handleInputChange("hvnly_propertyGridOrderByArea", val)}
          />
          <CopyShortcodeInput
            label={__("Random Order", "havenlytics")}
            id="hvnly_shortcode_grid_order_rand"
            value={settings.hvnly_propertyGridOrderByRand}
            onChange={(val) => handleInputChange("hvnly_propertyGridOrderByRand", val)}
          />

          <h3>{__("Pagination", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Hide Pagination", "havenlytics")}
            id="hvnly_shortcode_grid_hide_pagination"
            value={settings.hvnly_propertyGridHidePagination}
            onChange={(val) => handleInputChange("hvnly_propertyGridHidePagination", val)}
          />

          <h3>{__("Custom Class & ID", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Custom CSS Class & ID", "havenlytics")}
            id="hvnly_shortcode_grid_custom_class"
            value={settings.hvnly_propertyGridCustomClass}
            onChange={(val) => handleInputChange("hvnly_propertyGridCustomClass", val)}
          />

          <h3>{__("Results Bar Position", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Top", "havenlytics")}
            id="hvnly_shortcode_grid_results_bar_top"
            value={settings.hvnly_propertyGridResultsBarTop}
            onChange={(val) => handleInputChange("hvnly_propertyGridResultsBarTop", val)}
          />
          <CopyShortcodeInput
            label={__("Bottom", "havenlytics")}
            id="hvnly_shortcode_grid_results_bar_bottom"
            value={settings.hvnly_propertyGridResultsBarBottom}
            onChange={(val) => handleInputChange("hvnly_propertyGridResultsBarBottom", val)}
          />
          <CopyShortcodeInput
            label={__("Both", "havenlytics")}
            id="hvnly_shortcode_grid_results_bar_both"
            value={settings.hvnly_propertyGridResultsBarBoth}
            onChange={(val) => handleInputChange("hvnly_propertyGridResultsBarBoth", val)}
          />

          <h3>{__("Hide Results Count", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Hide Results Count", "havenlytics")}
            id="hvnly_shortcode_grid_hide_results_count"
            value={settings.hvnly_propertyGridHideResultsCount}
            onChange={(val) => handleInputChange("hvnly_propertyGridHideResultsCount", val)}
          />
        </div>
      </Card>

      <Card title={__("Property List Variations", "havenlytics")} icon="fas fa-list" collapsible defaultCollapsed>
        <div className={styles['hvnly-settings-api__form-group']}>
          <h3>{__("Basic List Views", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Basic List", "havenlytics")}
            id="hvnly_shortcode_list_basic"
            value={settings.hvnly_propertyListBasic}
            onChange={(val) => handleInputChange("hvnly_propertyListBasic", val)}
          />
          <CopyShortcodeInput
            label={__("Featured Only", "havenlytics")}
            id="hvnly_shortcode_list_featured"
            value={settings.hvnly_propertyListFeatured}
            onChange={(val) => handleInputChange("hvnly_propertyListFeatured", val)}
          />

          <h3>{__("Department Filters", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent", "havenlytics")}
            id="hvnly_shortcode_list_rent"
            value={settings.hvnly_propertyListRent}
            onChange={(val) => handleInputChange("hvnly_propertyListRent", val)}
          />
          <CopyShortcodeInput
            label={__("Sale", "havenlytics")}
            id="hvnly_shortcode_list_sale"
            value={settings.hvnly_propertyListSale}
            onChange={(val) => handleInputChange("hvnly_propertyListSale", val)}
          />
          <CopyShortcodeInput
            label={__("Commercial", "havenlytics")}
            id="hvnly_shortcode_list_commercial"
            value={settings.hvnly_propertyListCommercial}
            onChange={(val) => handleInputChange("hvnly_propertyListCommercial", val)}
          />
          <CopyShortcodeInput
            label={__("Let", "havenlytics")}
            id="hvnly_shortcode_list_let"
            value={settings.hvnly_propertyListLet}
            onChange={(val) => handleInputChange("hvnly_propertyListLet", val)}
          />

          <h3>{__("Featured + Department", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Featured Rent", "havenlytics")}
            id="hvnly_shortcode_list_featured_rent"
            value={settings.hvnly_propertyListFeaturedRent}
            onChange={(val) => handleInputChange("hvnly_propertyListFeaturedRent", val)}
          />
          <CopyShortcodeInput
            label={__("Featured Sale", "havenlytics")}
            id="hvnly_shortcode_list_featured_sale"
            value={settings.hvnly_propertyListFeaturedSale}
            onChange={(val) => handleInputChange("hvnly_propertyListFeaturedSale", val)}
          />

          <h3>{__("Price Range", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent ($200k - $500k)", "havenlytics")}
            id="hvnly_shortcode_list_price_range_rent"
            value={settings.hvnly_propertyListPriceRangeRent}
            onChange={(val) => handleInputChange("hvnly_propertyListPriceRangeRent", val)}
          />
          <CopyShortcodeInput
            label={__("Sale ($500k - $1M)", "havenlytics")}
            id="hvnly_shortcode_list_price_range_sale"
            value={settings.hvnly_propertyListPriceRangeSale}
            onChange={(val) => handleInputChange("hvnly_propertyListPriceRangeSale", val)}
          />

          <h3>{__("Bedrooms Filter", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent - 3 Bedrooms", "havenlytics")}
            id="hvnly_shortcode_list_bedrooms"
            value={settings.hvnly_propertyListBedrooms}
            onChange={(val) => handleInputChange("hvnly_propertyListBedrooms", val)}
          />
          <CopyShortcodeInput
            label={__("Sale - 4 Bedrooms", "havenlytics")}
            id="hvnly_shortcode_list_bedrooms_sale"
            value={settings.hvnly_propertyListBedroomsSale}
            onChange={(val) => handleInputChange("hvnly_propertyListBedroomsSale", val)}
          />
          <CopyShortcodeInput
            label={__("Rent - 2 Bedrooms Featured", "havenlytics")}
            id="hvnly_shortcode_list_bedrooms_featured"
            value={settings.hvnly_propertyListBedroomsFeatured}
            onChange={(val) => handleInputChange("hvnly_propertyListBedroomsFeatured", val)}
          />

          <h3>{__("Bathrooms Filter", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent - 2 Bathrooms", "havenlytics")}
            id="hvnly_shortcode_list_bathrooms"
            value={settings.hvnly_propertyListBathrooms}
            onChange={(val) => handleInputChange("hvnly_propertyListBathrooms", val)}
          />
          <CopyShortcodeInput
            label={__("Sale - 3 Bathrooms", "havenlytics")}
            id="hvnly_shortcode_list_bathrooms_sale"
            value={settings.hvnly_propertyListBathroomsSale}
            onChange={(val) => handleInputChange("hvnly_propertyListBathroomsSale", val)}
          />

          <h3>{__("Multiple Filters", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent: 3 Bed, 2 Bath, Featured", "havenlytics")}
            id="hvnly_shortcode_list_multiple_filters"
            value={settings.hvnly_propertyListMultipleFilters}
            onChange={(val) => handleInputChange("hvnly_propertyListMultipleFilters", val)}
          />
          <CopyShortcodeInput
            label={__("Sale: 4 Bed, 3 Bath, Min $500k", "havenlytics")}
            id="hvnly_shortcode_list_multiple_filters_sale"
            value={settings.hvnly_propertyListMultipleFiltersSale}
            onChange={(val) => handleInputChange("hvnly_propertyListMultipleFiltersSale", val)}
          />

          <h3>{__("Property Type", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Apartment for Rent", "havenlytics")}
            id="hvnly_shortcode_list_property_type_apartment"
            value={settings.hvnly_propertyListPropertyTypeApartment}
            onChange={(val) => handleInputChange("hvnly_propertyListPropertyTypeApartment", val)}
          />
          <CopyShortcodeInput
            label={__("House for Sale", "havenlytics")}
            id="hvnly_shortcode_list_property_type_house"
            value={settings.hvnly_propertyListPropertyTypeHouse}
            onChange={(val) => handleInputChange("hvnly_propertyListPropertyTypeHouse", val)}
          />
          <CopyShortcodeInput
            label={__("Condo for Rent", "havenlytics")}
            id="hvnly_shortcode_list_property_type_condo"
            value={settings.hvnly_propertyListPropertyTypeCondo}
            onChange={(val) => handleInputChange("hvnly_propertyListPropertyTypeCondo", val)}
          />

          <h3>{__("Location Filters", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("New York - Rent", "havenlytics")}
            id="hvnly_shortcode_list_location_ny"
            value={settings.hvnly_propertyListLocationNY}
            onChange={(val) => handleInputChange("hvnly_propertyListLocationNY", val)}
          />
          <CopyShortcodeInput
            label={__("Los Angeles - Sale", "havenlytics")}
            id="hvnly_shortcode_list_location_la"
            value={settings.hvnly_propertyListLocationLA}
            onChange={(val) => handleInputChange("hvnly_propertyListLocationLA", val)}
          />

          <h3>{__("Status Filters", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("For Sale", "havenlytics")}
            id="hvnly_shortcode_list_status_sale"
            value={settings.hvnly_propertyListStatusSale}
            onChange={(val) => handleInputChange("hvnly_propertyListStatusSale", val)}
          />
          <CopyShortcodeInput
            label={__("For Rent", "havenlytics")}
            id="hvnly_shortcode_list_status_rent"
            value={settings.hvnly_propertyListStatusRent}
            onChange={(val) => handleInputChange("hvnly_propertyListStatusRent", val)}
          />

          <h3>{__("Features", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Pool - Rent", "havenlytics")}
            id="hvnly_shortcode_list_feature_pool"
            value={settings.hvnly_propertyListFeaturePool}
            onChange={(val) => handleInputChange("hvnly_propertyListFeaturePool", val)}
          />
          <CopyShortcodeInput
            label={__("Garage & Garden - Sale", "havenlytics")}
            id="hvnly_shortcode_list_features_garage_garden"
            value={settings.hvnly_propertyListFeaturesGarageGarden}
            onChange={(val) => handleInputChange("hvnly_propertyListFeaturesGarageGarden", val)}
          />

          <h3>{__("Tags", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Luxury - Rent", "havenlytics")}
            id="hvnly_shortcode_list_tag_luxury"
            value={settings.hvnly_propertyListTagLuxury}
            onChange={(val) => handleInputChange("hvnly_propertyListTagLuxury", val)}
          />
          <CopyShortcodeInput
            label={__("Waterfront & New - Sale", "havenlytics")}
            id="hvnly_shortcode_list_tags_waterfront"
            value={settings.hvnly_propertyListTagsWaterfront}
            onChange={(val) => handleInputChange("hvnly_propertyListTagsWaterfront", val)}
          />

          <h3>{__("Badges", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Featured - Rent", "havenlytics")}
            id="hvnly_shortcode_list_badge_featured"
            value={settings.hvnly_propertyListBadgeFeatured}
            onChange={(val) => handleInputChange("hvnly_propertyListBadgeFeatured", val)}
          />
          <CopyShortcodeInput
            label={__("New & Popular - Sale", "havenlytics")}
            id="hvnly_shortcode_list_badges_new"
            value={settings.hvnly_propertyListBadgesNew}
            onChange={(val) => handleInputChange("hvnly_propertyListBadgesNew", val)}
          />

          <h3>{__("Area / Square Footage", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent - 1500 sqft", "havenlytics")}
            id="hvnly_shortcode_list_area_sqft"
            value={settings.hvnly_propertyListAreaSqft}
            onChange={(val) => handleInputChange("hvnly_propertyListAreaSqft", val)}
          />
          <CopyShortcodeInput
            label={__("Sale - 2000 area", "havenlytics")}
            id="hvnly_shortcode_list_area"
            value={settings.hvnly_propertyListArea}
            onChange={(val) => handleInputChange("hvnly_propertyListArea", val)}
          />

          <h3>{__("Garage", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent - 2 Garages", "havenlytics")}
            id="hvnly_shortcode_list_garage"
            value={settings.hvnly_propertyListGarage}
            onChange={(val) => handleInputChange("hvnly_propertyListGarage", val)}
          />

          <h3>{__("Year Built", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent - Built 2020", "havenlytics")}
            id="hvnly_shortcode_list_year_built"
            value={settings.hvnly_propertyListYearBuilt}
            onChange={(val) => handleInputChange("hvnly_propertyListYearBuilt", val)}
          />

          <h3>{__("Posts Per Page", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Rent - 10 per page", "havenlytics")}
            id="hvnly_shortcode_list_posts_per_page_10"
            value={settings.hvnly_propertyListPostsPerPage10}
            onChange={(val) => handleInputChange("hvnly_propertyListPostsPerPage10", val)}
          />
          <CopyShortcodeInput
            label={__("Sale - 15 per page", "havenlytics")}
            id="hvnly_shortcode_list_posts_per_page_15"
            value={settings.hvnly_propertyListPostsPerPage15}
            onChange={(val) => handleInputChange("hvnly_propertyListPostsPerPage15", val)}
          />

          <h3>{__("Specific Property IDs", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Include Specific Properties", "havenlytics")}
            id="hvnly_shortcode_list_specific_ids"
            value={settings.hvnly_propertyListSpecificIds}
            onChange={(val) => handleInputChange("hvnly_propertyListSpecificIds", val)}
          />

          <h3>{__("Exclude Property IDs", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Exclude Specific Properties", "havenlytics")}
            id="hvnly_shortcode_list_exclude_ids"
            value={settings.hvnly_propertyListExcludeIds}
            onChange={(val) => handleInputChange("hvnly_propertyListExcludeIds", val)}
          />

          <h3>{__("Custom Ordering", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Price: Low to High", "havenlytics")}
            id="hvnly_shortcode_list_order_price_low"
            value={settings.hvnly_propertyListOrderByPriceLow}
            onChange={(val) => handleInputChange("hvnly_propertyListOrderByPriceLow", val)}
          />
          <CopyShortcodeInput
            label={__("Price: High to Low", "havenlytics")}
            id="hvnly_shortcode_list_order_price_high"
            value={settings.hvnly_propertyListOrderByPriceHigh}
            onChange={(val) => handleInputChange("hvnly_propertyListOrderByPriceHigh", val)}
          />
          <CopyShortcodeInput
            label={__("Date: Oldest First", "havenlytics")}
            id="hvnly_shortcode_list_order_date_asc"
            value={settings.hvnly_propertyListOrderByDateAsc}
            onChange={(val) => handleInputChange("hvnly_propertyListOrderByDateAsc", val)}
          />
          <CopyShortcodeInput
            label={__("Date: Newest First", "havenlytics")}
            id="hvnly_shortcode_list_order_date_desc"
            value={settings.hvnly_propertyListOrderByDateDesc}
            onChange={(val) => handleInputChange("hvnly_propertyListOrderByDateDesc", val)}
          />
          <CopyShortcodeInput
            label={__("Title: A to Z", "havenlytics")}
            id="hvnly_shortcode_list_order_title_asc"
            value={settings.hvnly_propertyListOrderByTitleAsc}
            onChange={(val) => handleInputChange("hvnly_propertyListOrderByTitleAsc", val)}
          />
          <CopyShortcodeInput
            label={__("Title: Z to A", "havenlytics")}
            id="hvnly_shortcode_list_order_title_desc"
            value={settings.hvnly_propertyListOrderByTitleDesc}
            onChange={(val) => handleInputChange("hvnly_propertyListOrderByTitleDesc", val)}
          />
          <CopyShortcodeInput
            label={__("By Bedrooms", "havenlytics")}
            id="hvnly_shortcode_list_order_bedrooms"
            value={settings.hvnly_propertyListOrderByBedrooms}
            onChange={(val) => handleInputChange("hvnly_propertyListOrderByBedrooms", val)}
          />
          <CopyShortcodeInput
            label={__("By Bathrooms", "havenlytics")}
            id="hvnly_shortcode_list_order_bathrooms"
            value={settings.hvnly_propertyListOrderByBathrooms}
            onChange={(val) => handleInputChange("hvnly_propertyListOrderByBathrooms", val)}
          />
          <CopyShortcodeInput
            label={__("By Area", "havenlytics")}
            id="hvnly_shortcode_list_order_area"
            value={settings.hvnly_propertyListOrderByArea}
            onChange={(val) => handleInputChange("hvnly_propertyListOrderByArea", val)}
          />
          <CopyShortcodeInput
            label={__("Random Order", "havenlytics")}
            id="hvnly_shortcode_list_order_rand"
            value={settings.hvnly_propertyListOrderByRand}
            onChange={(val) => handleInputChange("hvnly_propertyListOrderByRand", val)}
          />

          <h3>{__("Pagination", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Hide Pagination", "havenlytics")}
            id="hvnly_shortcode_list_hide_pagination"
            value={settings.hvnly_propertyListHidePagination}
            onChange={(val) => handleInputChange("hvnly_propertyListHidePagination", val)}
          />

          <h3>{__("Custom Class & ID", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Custom CSS Class & ID", "havenlytics")}
            id="hvnly_shortcode_list_custom_class"
            value={settings.hvnly_propertyListCustomClass}
            onChange={(val) => handleInputChange("hvnly_propertyListCustomClass", val)}
          />

          <h3>{__("Results Bar Position", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Top", "havenlytics")}
            id="hvnly_shortcode_list_results_bar_top"
            value={settings.hvnly_propertyListResultsBarTop}
            onChange={(val) => handleInputChange("hvnly_propertyListResultsBarTop", val)}
          />
          <CopyShortcodeInput
            label={__("Bottom", "havenlytics")}
            id="hvnly_shortcode_list_results_bar_bottom"
            value={settings.hvnly_propertyListResultsBarBottom}
            onChange={(val) => handleInputChange("hvnly_propertyListResultsBarBottom", val)}
          />
          <CopyShortcodeInput
            label={__("Both", "havenlytics")}
            id="hvnly_shortcode_list_results_bar_both"
            value={settings.hvnly_propertyListResultsBarBoth}
            onChange={(val) => handleInputChange("hvnly_propertyListResultsBarBoth", val)}
          />

          <h3>{__("Hide Results Count", "havenlytics")}</h3>
          <CopyShortcodeInput
            label={__("Hide Results Count", "havenlytics")}
            id="hvnly_shortcode_list_hide_results_count"
            value={settings.hvnly_propertyListHideResultsCount}
            onChange={(val) => handleInputChange("hvnly_propertyListHideResultsCount", val)}
          />
        </div>
      </Card>
    </div>
  );
};

export default ShortcodesSettings;